// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3tqHm","infoBtn":"quickbooks_infoBtn__1GXlM","formBox":"quickbooks_formBox__JLMYK","formFooter":"quickbooks_formFooter__3ISBi"};